import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: [
    'Project',
    'ProjectList',
    'ProjectAssignments',
    'ProjectLayout',
    'DwgImports',
    'DwgData'
  ],
  endpoints: () => ({})
})

export default projectApi
